/* eslint-disable @typescript-eslint/no-explicit-any */
import Popconfirm from "antd/es/popconfirm";
import BreadCrumb from "../../../components/BreadCrumb";
import { PublishButton } from "../../../components/PublishButton";
import EditButton from "../../../components/EditButton";

const ApiProjectHeader = ({
  isWorkspaceView,
  title,
  projectDetail,
  isEditMode,
  setIsEditMode,
  publishTableProject,
  unpublishTableProject
}: {
  isWorkspaceView?: boolean
  title?: string
  projectDetail?: any
  setIsEditMode?: any
  isEditMode?: boolean
  publishTableProject?: any
  unpublishTableProject?: any
}) => {
  return <div className="flex justify-between items-center px-8 py-3">
    <div className="flex gap-6 items-center">
      <div>
        <BreadCrumb>
          {title || 'API Project'}
        </BreadCrumb>
      </div>
      {
        isWorkspaceView ?
          <div className="text-sm text-[#999ca0]">
            Edited 12 hours ago
            {/* Use moment here to get relative time */}
          </div> : <div className="text-sm text-[#999ca0] flex items-center gap-2">
            <div className="w-6 h-6 bg-[#e3e3e3] rounded"></div>
            {projectDetail?.owner?.name || 'Unknown Owner'}
            {/* Use moment here to get relative time */}
          </div>
      }
    </div>
    <div className="flex gap-2">
      {
        isWorkspaceView &&
        (projectDetail?.status !== 1 ? <Popconfirm
          title="Publish Table Project"
          description="Are you sure to publish this project?"
          okText="Yes"
          cancelText="No"
          onConfirm={publishTableProject}
        >
          < PublishButton />
        </Popconfirm> :
          <Popconfirm
            key={'unpublish'}
            title="Unpublish Table Project"
            description="Are you sure to unpublish this project?"
            okText="Yes"
            cancelText="No"
            onConfirm={unpublishTableProject}
          >
            <PublishButton text="Unpublish" />
          </Popconfirm>
        )
      }
      {
        !isEditMode && isWorkspaceView && <EditButton onClick={
          () => setIsEditMode(true)
        } showText />
      }
    </div>
  </div>
}

export default ApiProjectHeader;